import script from "./DevHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./DevHistory.vue?vue&type=script&lang=ts&setup=true"

import "./DevHistory.vue?vue&type=style&index=0&id=9fe030da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fe030da"]])

export default __exports__